var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
import { mapApiBankAccount, mapCreateBankAccountPayload, } from "./bankAccount.utils";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getInfiniteLoad = _a.getInfiniteLoad;
export var getAllMissingKYCs = function () {
    return api.get("/".concat(GENERATOR_PARAMS.basePathEntity, "/missing-kycs"), { isV2: true });
};
export var removeBankAccount = function (id) {
    return api.patch("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/remove"), { isV2: true });
};
/**
 * Corrects the owner name. The IBAN is not part of the payload and cannot be
 * changed. The response is a *different* bank account: a Mangopay recipient is
 * immutable, so the API replaces the account rather than editing it.
 */
export var updateBankAccountOwnerName = function (id, data) {
    return api.patch("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/owner-name"), { isV2: true, data: data });
};
var getContactBankAccountsPath = function (contactId) {
    return "/contacts/".concat(contactId, "/").concat(GENERATOR_PARAMS.basePathEntity);
};
/**
 * The bank accounts of one contact.
 *
 * The `{ data: { items } }` envelope is unwrapped here so callers keep receiving
 * a plain array, the way the V1 route answered. Note that V2 formats the IBAN in
 * blocks of four ("BE68 5390 0754 7034") where V1 sent it without spaces.
 *
 * Guarded on the API by the contact's `MASTER_PERSONAL_CONTACT` / `OWNER` roles
 * (Rentio admins pass), so the caller has to own the contact it asks about.
 */
export var getBankAccountsForContact = function (contactId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get(getContactBankAccountsPath(contactId), { isV2: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, __assign(__assign({}, response), { data: response.data.data.items.map(mapApiBankAccount) })];
        }
    });
}); };
export var createBankAccountForContact = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var contactId, data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                contactId = params.contactId, data = params.data;
                return [4 /*yield*/, api.post(getContactBankAccountsPath(contactId), { isV2: true, data: mapCreateBankAccountPayload(data) })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, __assign(__assign({}, response), { data: mapApiBankAccount(response.data.data) })];
        }
    });
}); };
